import { CreateContentDeepLinkParams, CreateContentDeepLinkResponse } from './types';

import { FailureActionPayload } from 'store/errors/types';
import { createAsyncAction } from 'typesafe-actions';

export const createServiceContentDeeplink = createAsyncAction(
  'CREATE_SERVICE_CONTENT_DEEPLINK_REQUEST',
  'CREATE_SERVICE_CONTENT_DEEPLINK_SUCCESS',
  'CREATE_SERVICE_CONTENT_DEEPLINK_FAILURE',
)<CreateContentDeepLinkParams, CreateContentDeepLinkResponse, FailureActionPayload>();
